import {cn} from '@sollapay/ui';
import {Skeleton} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** Holds the log's place while either log loads, so the merged list never shows half the changes. */
export const ShareChangeLogSkeleton: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ul
      data-slot="share-change-log-skeleton"
      aria-label={t('share.log.label')}
      aria-busy
      className="flex flex-col divide-y divide-border-subtle"
    >
      {Array.from({length: 4}, (_, index) => (
        <li key={index} className="flex gap-2.5 py-2.5">
          <Skeleton className="mt-1.5 size-2 shrink-0 rounded-full" />
          <span className="flex flex-1 flex-col gap-1.5">
            <Skeleton className={cn('h-4', index % 2 ? 'w-3/5' : 'w-4/5')} />
            <Skeleton className="h-3 w-20" />
          </span>
        </li>
      ))}
    </ul>
  );
};
